import { render, staticRenderFns } from "./PreferencesDefaultDayTime.vue?vue&type=template&id=f5dad7d2"
import script from "./PreferencesDefaultDayTime.vue?vue&type=script&lang=js"
export * from "./PreferencesDefaultDayTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports